<template>
  <div class="DarkWhite pa-4">
    <v-row>
    <v-col cols="12" sm="6" md="8" lg="10">
        <h2 class="subheading green--text">Transaction Monitoring</h2>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-autocomplete
          v-model="fiscalYear"
          :items="fiscalyears"
          auto-select-first
          item-text="fiscalYear"
          item-value="id"
          color="header"
          dense
          label="Fiscal Year"
          class="mt-2"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <div>
      <v-data-table
        :headers="headers"
        :items="budgetMonitoringData"
        :options.sync="options"
        :server-items-length="totalCount"
        :loading="loading"
        :footer-props="footerProps"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-row align="center" class="mx-3">
            <v-col cols="12" sm="6">
            <v-text-field
              v-model="searchText"
              append-icon="mdi-magnify"
              placeholder="Search for a Code"
              color="green darken-2"
              class="mb-2 mr-2"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="text-center text-sm-right">
            <v-btn
              outlined
              color="secondary"
              dark
              small
              @click="resetFilter()"
              class="mr-2"
            >
              <v-icon>refresh</v-icon>
              Reset Filter
            </v-btn>
            <v-btn
              outlined
              color="red darken-2"
              dark
              small
              @click="printTransactions()"
            >
              <v-icon>print</v-icon>
              Print
            </v-btn>
            </v-col>
          </v-row>
          <!----date range----->
          <v-row align="center" class="mx-3 mt-3" no-gutters>
            <v-col cols="12" md="4">
              <v-icon>mdi-filter</v-icon> Filter by Date Range:
            </v-col>
            <v-col cols="12" md="8" class="flex-items mt-3">
            <v-menu
              dense
              ref="date_menu1"
              v-model="date_menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              class="mb-4"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="date_start"
                  label="Date Start"
                  color="green darken-2"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="mr-5"
                  @change="getBudgetMonitoring()"
                ></v-combobox>
              </template>
              <v-date-picker v-model="date_start" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="date_menu1 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="date_menu1 = false"> OK </v-btn>
              </v-date-picker>
            </v-menu>
            <v-menu
              dense
              ref="date_menu2"
              v-model="date_menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              class="mb-4"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="date_end"
                  label="Date End"
                  color="green darken-2"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker v-model="date_end" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="date_menu2 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="date_menu2 = false"> OK </v-btn>
              </v-date-picker>
            </v-menu>
            </v-col>
          </v-row>
          <!----date range----->
          <v-row align="center" class="mx-3" no-gutters>
            <v-col cols="12" md="4">
              <v-icon>mdi-filter</v-icon> Filter by Transaction:
            </v-col>
            <v-col cols="12" md="8">
              <v-row align="center" no-gutters>
                <v-col cols="12" sm="4">
                  <v-checkbox
                    v-model="filter_pr"
                    color="green darken-2"
                    class="mt-2"
                    label="Purchase Request"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-checkbox
                    v-model="filter_po"
                    color="green darken-2"
                    class="mt-2"
                    label="Purchase Order"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-checkbox
                    v-model="filter_iar"
                    color="green darken-2"
                    class="mt-2"
                    label="Inspection and Acceptance Report"
                  ></v-checkbox>
                </v-col>
              </v-row>
          </v-col>
          </v-row>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    date_menu1: false,
    date_menu2: false,
    date_start: '',
    date_end: '',
    filter_pr: false,
    filter_po: false,
    filter_iar: false,
    checkbox: true,
    value: [0, 1, 5, 0, 0, 2, 3, 1, 0, 0, 2, 5],
    searchText: "",
    searchTimeout: null,
    amountErr: null,
    footerProps: { "items-per-page-options": [10, 20, 50, 100, 500, -1] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    addPPMPDialog: false,
    budgetMonitoringData: [],
    headers: [
      {
        text: "PPMP Budget Code",
        align: "start",
        sortable: false,
        value: "BudgetCode",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      // {
      //   text: "PPMP Budget Date",
      //   align: "start",
      //   sortable: false,
      //   value: "BudgetCode",
      //   class: "green darken-2 white--text text-caption font-weight-bold",
      // },
      {
        text: "PPMP Description",
        value: "PPMPDescription",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Code",
        value: "PR_CODE",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Date",
        value: "PRDateCreated",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PO Code",
        value: "POCode",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PO Date",
        value: "PODateCreated",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Date Delivered",
        align: "start",
        sortable: false,
        value: "DateDelivered",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "IAR Code",
        value: "IARCode",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "IAR Date",
        value: "IRARDateCreated",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Date Received",
        value: "DateReceived",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Status",
        value: "Status",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
    ],
    fiscalYear: null,
    fiscalyears: [],
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    date_start: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    date_end: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    filter_pr: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    filter_po: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    filter_iar: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler(data) {
        this.$store.dispatch("setFiscalYear", data);
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.getFiscalYears()
    this.eventHub.$on("closePPMPModal", () => {
      this.ppmpItem = {};
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closePPMPModal");
  },
  methods: {
    viewPPMP(item) {
      this.ppmpItem = item;
    },
    initialize() {
      this.loading = true;
      if(this.fiscalYear != null){
      this.getBudgetMonitoring();
      }
    },
    getBudgetMonitoring() {
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("searchText", this.searchText);
      data.append("date_start", this.date_start);
      data.append("date_end", this.date_end);
      data.append("filter_pr", this.filter_pr ? 1 : 0);
      data.append("filter_po", this.filter_po ? 1 : 0);
      data.append("filter_iar", this.filter_iar ? 1 : 0);
      data.append("FiscalYearID", this.fiscalYear);
      this.axiosCall("/dashboard/budgetMonitoring", "POST", data).then(
        (res) => {
          this.loading = false;
          this.budgetMonitoringData = res.data.data.result;
          this.totalCount = res.data.data.total;
          if (this.totalCount <= 10) {
            this.options.page = 1;
          }
        }
      );
    },
    printTransactions(){
      let pr = this.filter_pr ? 1 : 0;
      let po = this.filter_po ? 1 : 0;
      let iar = this.filter_iar ? 1 : 0;
      let date_start = this.date_start != '' ? this.date_start : 0;
      let date_end = this.date_end != '' ? this.date_end : 0;
      let searchText = this.searchText != '' ? this.searchText : 0;
      window.open(this.apiUrl + "/transaction/report/" + searchText + "/" + date_start + "/" + date_end + "/" + pr + "/" + po + "/" + iar);
    },
    resetFilter(){
      this.searchText = '';
      this.date_start = '';
      this.date_end = '';
      this.filter_pr = false;
      this.filter_po = false;
      this.filter_iar = false
    },
    getFiscalYears() {
      this.fiscalyears = [{id: 0, fiscalYear: "All"}]
      this.axiosCall("/getAllFiscalYear", "GET").then((res) => {
        this.fiscalyears = [{id: 0, fiscalYear: "All"}, ...res.data.data]
        this.fiscalYear = this.$store.state.fiscalYear != null ? this.$store.state.fiscalYear : res.data.data[0].id
      });
    }, 
  },
};
</script>